import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_EM_67 } from "@/lib/programData";

export default function ErgMarrakech67Page() {
  return <ProgramTemplate program={PROGRAM_EM_67} variant="em" showJourneyChronology />;
}
